import './ContentBlock.css'

export function ContentBlock({className, header, children}) {
    return (
        <div className={`${className} contentblock`}>
            <ContentBlockHeader header={header}/>
            <div className="contentblock-body">
                {children}
            </div>
        </div>
    )
}

function ContentBlockHeader({header}) {
    if (!header) return null;

    return (
        <div className="contentblockheader">
            {header.split(' ').map((word, i) => (
                <span key={i}>
                    <span className="contentblockheader-large">{word[0]}</span>
                    <span className="contentblockheader-small">{word.slice(1)}</span>
                </span>
            ))}
        </div>
    );
}